// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","col":"Header_col__wwvFT","links-container":"Header_links-container__Xjoa2"};